// Import the patch before using react-virtualized components
import { setupInjectStores } from "@intrasync/react";
import "./react-virtualized-patch";
import "./main.css";
import appStores from "./appStoresConfig";
import serviceStores from "serviceStoresConfig";

import { pwaRegistration } from "./pwaUtils";
import { renderApp } from "./renderApp";
import { createRootStore } from "./createRootStore";

const rootStore = createRootStore();

// Dev-only handle for e2e/automation (Playwright walkthroughs, debugging):
// lets tooling drive routerStore/authStore directly. Never set in prod builds.
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__hqRootStore = rootStore;
}

pwaRegistration(rootStore);

setupInjectStores(appStores, serviceStores)
  .then(() => {
    // Stores setup complete
    renderApp(rootStore);
  })
  .catch((error) => {
    console.error("Error setting up stores", error);
  });
